import React, { useState, useRef } from "react";
import { useNavigate } from 'react-router-dom'; 
import styled from "styled-components";
import '../Styles/background.css'; // Import the CSS file

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 100vh;
  font-family: "Roboto", sans-serif;
`;

const Header = styled.div`
  width: 100%;
  background: #719e19;
  padding: 20px;
  color: white;
  text-align: center;
  border-bottom-left-radius: 40px;
  border-bottom-right-radius: 40px;
  box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.2);
  margin-bottom: 30px;
`;

const OTPContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
`;

const OTPInput = styled.input`
  width: 70px;
  height: 70px;
  font-size: 24px;
  font-weight: bold;
  text-align: center;
  border-radius: 20px;
  border: 2px solid #719e19;
  color: #719e19;
  margin: 0 5px;
  outline: none;
  transition: border-color 0.3s ease;
  &:focus {
    border-color: #0056b3;
  }
`;

const VerifyButton = styled.button`
  width:80%;
  padding: 12px 25px;
  font-size: 18px;
  cursor: pointer;
  transition: background-color 0.3s ease, transform 0.3s ease;
  &:hover {
    background-color: #0056b3;
    transform: scale(1.05);
  }
  &:disabled {
    background-color: #ccc;
    cursor: not-allowed;
  }
`;

const MobileOTP = () => {
  const navigate = useNavigate();
  const [otpNumbers, setOtpNumbers] = useState(["", "", "", ""]);
  const inputsRef = useRef([]);

  const handleInputChange = (e, index) => {
    const { value } = e.target;
    const updatedOtpNumbers = [...otpNumbers];
    if (/^\d*$/.test(value)) {
      updatedOtpNumbers[index] = value;
      setOtpNumbers(updatedOtpNumbers);
    }
    if (index < otpNumbers.length - 1 && value.length === 1) {
      inputsRef.current[index + 1]?.focus();
    }
  };

  const handleBackspace = (index, e) => {
    if (e.keyCode === 8 && index > 0 && !otpNumbers[index]) {
      const updatedOtpNumbers = [...otpNumbers];
      updatedOtpNumbers[index - 1] = "";
      setOtpNumbers(updatedOtpNumbers);
      inputsRef.current[index - 1]?.focus();
    }
  };

  const isAllOtpFilled = otpNumbers.every((num) => num !== "");

  const handleVerify = () => {

    navigate('/success');
   /// alert("OTP Verified: " + otpNumbers.join(""));
  };

  return (
    <Container className="mobile-insurance">
    
      <div className="d-flex justify-content-end align-items-center flex-column" style={{ flex: 1,marginBottom:'5%' }}>
        <div className="text-center card bg-light mb-2">
          <h4 className="p-3">
            Please enter the OTP shared with you on the Mobile Number: 03145362496
          </h4>
        </div>
        <OTPContainer>
          {otpNumbers.map((otp, index) => (
            <OTPInput
              key={index}
              ref={(ref) => (inputsRef.current[index] = ref)}
              value={otp}
              onChange={(e) => handleInputChange(e, index)}
              onKeyDown={(e) => handleBackspace(index, e)}
              maxLength="1"
              type="tel"
            />
          ))}
        </OTPContainer>
        <VerifyButton className="btn btn-primary" onClick={isAllOtpFilled ? handleVerify : null} disabled={!isAllOtpFilled}>
          Verify
        </VerifyButton>
      </div>
    </Container>
  );
};

export default MobileOTP;
